<template>
  <div class="elite-tabs-wrapper-content">
    <h3 class="mb-4">{{ `${product.name}` }} - {{ $t("COMMON.SUPPLIERS") }}</h3>
    <supplier-product-list
      :filterProduct="product.id"
      :filterOrganization="product.organization.id"
      :product="product"
      :addLineText="$t('PRODUCTS.ADD_SUPPLIER')"
    />
  </div>
</template>
<script>
import SupplierProductList from "@/components/SupplierProduct/SupplierProductList.vue";

export default {
  name: "product-view-supplier-products",

  components: {
    SupplierProductList,
  },

  props: ["product"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {},
};
</script>
